/**
 * PolicyIntel Signal System runtime colors.
 *
 * CSS custom properties remain the visual authority for ordinary DOM/CSS.
 * Some JavaScript libraries parse colors before the browser can resolve
 * `var(--pi-*)` (MUI alpha(), lightweight-charts, canvas helpers, etc.).
 * Those boundaries must receive concrete CSS color strings.
 *
 * Keep these values synchronized with policy-signal-system.css.
 */
export const PI_RUNTIME = {
  ink: '#07111f',
  inkSoft: '#142235',
  blue: '#2968ff',
  blueStrong: '#1f55d8',
  cyan: '#35b9e9',

  positive: '#168a5b',
  positiveSoft: '#eaf7f1',
  watch: '#c78118',
  watchSoft: '#fff5e5',
  risk: '#d94a4a',
  riskSoft: '#fff0f0',
  neutral: '#6f7f91',
  neutralSoft: '#f2f5f8',

  canvas: '#f4f7fa',
  surface: '#ffffff',
  surfaceSubtle: '#edf2f6',
  surfaceResearch: '#f8fafc',

  text: '#07111f',
  textSecondary: '#596779',
  textMuted: '#8491a1',

  borderQuiet: '#e2e8ef',
  borderStrong: '#cbd5df',
} as const;

export type PolicyRuntimeColorKey = keyof typeof PI_RUNTIME;
